import { FC } from 'react';
import { AddressType } from '../types';
import { getDisplayName } from '../utils';
import styles from './formats.module.scss';
interface DefaultFormatAddressProps {
  isFullAddress?: boolean;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
  isAsianOrder?: boolean;
  isCompanyNameAddressFlag?: boolean;
  isDropboxAddress?: boolean;
}

export const DefaultFormatAddress: FC<DefaultFormatAddressProps> = ({
  isFullAddress,
  address,
  isAddressTypeDisplay,
  translatedAddressType,
  isAsianOrder,
  isCompanyNameAddressFlag,
  isDropboxAddress = false
}) => {
  const {
    address1,
    address2,
    firstName,
    middleName,
    lastName,
    city,
    country,
    email,
    phone,
    state,
    zipCode,
    companyName,
    address3
  } = address;
  const statePrefix = city && state ? ', ' : '';
  const zipCodePrefix = (city || state) && zipCode ? ' ' : '';
  const cityPrefix = city && state ? ' ' : '';

  return (
    <div data-testid="address-default" className={styles['formats']}>
      {isAddressTypeDisplay && (
        <p className="cat-u-theme-typography-label mb-0" data-cs-encrypt>
          {translatedAddressType}
        </p>
      )}
      {isAsianOrder ? (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {getDisplayName(lastName, firstName)}
        </p>
      ) : (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {getDisplayName(firstName, middleName, lastName)}
        </p>
      )}
      {companyName && isCompanyNameAddressFlag && (
        <p className="mb-0 exclude-global" data-cs-mask>
          {companyName}
        </p>
      )}
      {!isAsianOrder && address1 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address1}
        </p>
      )}
      {!isAsianOrder && address2 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address2}
        </p>
      )}
      {isDropboxAddress && address3 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address3}
        </p>
      )}
      {!isAsianOrder && (city || state || zipCode) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {city}
          {statePrefix}
          {state}
          {zipCodePrefix}
          {zipCode}
        </p>
      )}
      {isAsianOrder && (city || state || zipCode) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {zipCode}
          {zipCodePrefix}
          {state}
          {cityPrefix}
          {city}
        </p>
      )}
      {isAsianOrder && address1 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address1}
        </p>
      )}
      {isAsianOrder && address2 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address2}
        </p>
      )}
      {country && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {country}
        </p>
      )}
      {phone && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {phone}
        </p>
      )}
      {email && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {email}
        </p>
      )}
    </div>
  );
};
